import { oc } from '@orpc/contract';
import { updateValidityRuleInputSchema, validityRuleSchema } from '../schemas/config.schemas.js';
export const updateValidityRuleContract = oc
    .route({
    method: 'PUT',
    path: '/config/validity-rules/{id}',
    tags: ['Config'],
    summary: 'Replace a validity rule’s definition, severity and status',
    description: 'MANAGER only. The rule key and its protocol never change, so a historical run stays traceable to a rule that still exists.',
})
    .input(updateValidityRuleInputSchema)
    .output(validityRuleSchema);
//# sourceMappingURL=update-validity-rule.contract.js.map